export class InvSerialEntity{
    id:number;
    coutingId:number;
    serial:string;
    mac:string;
    sapCode:string;
    sapCodeSap:string;
    sapCodeWms:string;
    sapCodeBase:string;
    status:string;
    statusSap:string;
    statusWms:string;
    statusBase:string;
    pallet:string;
    palletSap:string;
    palletWms:string;
    adjustment:string;
    creationDate:string;
    creationUserId:number;

    constructor(){}
}